import { Component, OnInit, Input, OnDestroy, HostBinding, OnChanges, SimpleChange, HostListener, ElementRef, ViewChild } from '@angular/core';
declare var $ :any;

@Component({
  selector: 'input-dropdown',
  templateUrl: './input-dropdown.component.html',
  styleUrls: ['./input-dropdown.component.scss'],
  host:{"(click)": "toggle($event,true)"}
})

export class InputDropdownComponent implements OnInit, OnDestroy, OnChanges {

  
  @Input() searchField: Boolean = false;
  @Input() active: Boolean = false;
  @Input() multiple: Boolean = false;
  @Input() inline: Boolean = false;
  @Input() class: string = '';
  @Input() placeholder: string = '';
  @Input() text: any = '';
  @Input() event: any = '';
  @Input() empty: any = false;
  @Input() seted: Boolean = false;
  @Input() disabled: Boolean = false;
  
  @HostBinding('className') className = this.class;

  @ViewChild('content', {static:false, read:ElementRef}) content:ElementRef;

  emptyActive = false;

  @HostListener('document:click', ['$event'])
  public onClick(targetElement) {
      this.close(targetElement);
  }
  @HostListener('window:resize', ['$event'])
  public onResize(event) {
      this.setText();
  }
  
  constructor(private _view: ElementRef) {
  }

  ngOnInit() {
    this.updateClassName();
    this.setText();
  }
  ngOnDestroy(){
    
  }

  setText(){
    if(this.text instanceof Array){
      let nText = [];
      this.text.map(item => {
        if(item.text)
          nText.push('<div class="col-auto '+(item?.class || '')+'">'+item.text+(item?.prefix? '<p>'+item.prefix+'</p> ':'')+'</div>');
      });
      this.text = nText.join(' ');
    } else if(typeof this.text != 'undefined' && this.text != '' && this.text.indexOf('<span') == -1 && this.text.indexOf('<div') == -1) { 
      this.text = '<div class="col">' + this.text + '</div>';
    }
    let el = $(this._view.nativeElement);
    let th = this;
    setTimeout(function(){
      let seted = false;
      
      el.find('.text > span, .text > div').each(function(){
          if($(this).css('display') != 'none')
            seted = true;
      });
      th.seted = seted;
      
      if((th.inline || !th.multiple) && (typeof th.event?.type == 'undefined' || th.event?.type!='keyup'))
        th.close('all');
    },10);
  }

  ngOnChanges(changes: { [key: string]: SimpleChange }) {
    
    if(changes?.text)
      this.setText();
      
    if(changes?.active)
      this.updateClassName();
  }

  updateClassName(){
    this.className = [this.class, this.inline? 'inline' : '', this.active? 'active' : ''].join(' ');
  }

  toggle(event){
    if($(event.target)[0] != $(this._view.nativeElement)[0] || this.disabled)
      return;
  
    this.active = !this.active;

    if(this.active){
      if(this.searchField || this.class.indexOf('onActive') > -1 || this.class.indexOf('focusWhenOpen') > -1){
        let input =  $(this._view.nativeElement.querySelector('.mat-input-element')).first();
        var th = this;
        if(this.inline){
          input.on('focus', (e) => { th.active = true; th.updateClassName(); });
          input.on('blur', (e) => th.close(null));
        }

        setTimeout(() => input?.focus(), 20);
      } else
        this._view.nativeElement.querySelector('.btn-filter')?.focus();
    }
    let el = $(this._view.nativeElement);
    let offset = el.offset();
    let height = el.height();
    //this.content.nativeElement.style.setProperty('max-height', 'calc(100vh - 3rem - '+(offset.top+height)+'px)');

    this.updateClassName();  
  }

  close(event = null){
    
    if(event?.target && (!!$(this._view.nativeElement).has($(event.target)).length || $(event.target)[0] == $(this._view.nativeElement)[0])){
      if(this.empty && !this.seted && !this.active){
        this.emptyActive = true;
        setTimeout(() => this.emptyActive = false, 1200);
      }


      return false;
    }
      
    this.active = false;
    this.updateClassName();
  }

}
